import S from 'pull-stream/pull';
S.values = require('pull-stream/sources/values');
S.once = require('pull-stream/sources/once');
S.fromCb = require('pull-async');
S.map = require('pull-stream/throughs/map');
S.filter = require('pull-stream/throughs/filter');
S.asyncMap = require('pull-stream/throughs/async-map');
S.through = require('pull-stream/throughs/through');
S.collect = require('pull-stream/sinks/collect');
S.cat = require('pull-cat');
S.scan = require('pull-scan');
S.many = require('pull-many');
S.flatMerge = require('pull-flat-merge');
S.catch = require('pull-catch');

// used for testing
S.asyncValues = function asyncValues (arr) {
    return S(
        S.values(arr),
        S.asyncMap(function (ev, cb) {
            process.nextTick(function () {
                cb(null, ev);
            });
        })
    );
};

export default S;
